import React from 'react'
import {formatRangeLabel} from 'features/search/utils'
import styles from './FiltersCrumbs.scss'
import {Icon} from 'common/Icon'
import {SEARCH_MAX, LENGTH_MAX, ELEVATION_MAX} from 'lib/api/search'

class SearchRangeCrumb extends React.PureComponent {
  onClick = () => {
    const {doSearch, query} = this.props

    const clearedQuery = query.merge({
      start_distance: SEARCH_MAX,
      start_location: ''
    })
    doSearch(clearedQuery)
  }

  render () {
    const {distance, location, metricUnits} = this.props
    const unitLabel = metricUnits ? 'kilometers' : 'miles'

    if (distance === SEARCH_MAX && location === '') {
      return null
    }

    const hasDistance = distance && distance !== SEARCH_MAX
    const hasLocation = location && location !== ''
    const distanceLabel = hasDistance && `${distance} ${unitLabel}`
    const locationLabel = hasLocation && `${location}`

    return (hasDistance || hasLocation) && (
      <div className={styles.Crumb} onClick={this.onClick}>
        {distanceLabel}{distanceLabel && locationLabel && ' of '}{locationLabel}
        <span className={styles.close}>
          <Icon i={'md-close'} />
        </span>
      </div>
    )
  }
}

class LengthCrumb extends React.PureComponent {
  onClick = () => {
    const {doSearch, query} = this.props

    const clearedQuery = query.merge({
      length_min: 0,
      length_max: LENGTH_MAX
    })
    doSearch(clearedQuery)
  }

  render () {
    const {lengthMin, lengthMax, metricUnits} = this.props
    const unitLabel = metricUnits ? 'kilometers' : 'miles'

    if (lengthMin === 0 && lengthMax === LENGTH_MAX) {
      return null
    }

    return (
      <div className={styles.Crumb} onClick={this.onClick}>
        {formatRangeLabel(lengthMin, lengthMax, 0, LENGTH_MAX, 'length', unitLabel)}
        <span className={styles.close}>
          <Icon i={'md-close'} />
        </span>
      </div>
    )
  }
}

class ElevationCrumb extends React.PureComponent {
  onClick = () => {
    const {doSearch, query} = this.props

    const clearedQuery = query.merge({
      elevation_min: 0,
      elevation_max: ELEVATION_MAX
    })
    doSearch(clearedQuery)
  }

  render () {
    const {elevationMin, elevationMax, metricUnits} = this.props
    const unitLabel = metricUnits ? 'meters' : 'feet'

    if (elevationMin === 0 && elevationMax === ELEVATION_MAX) {
      return null
    }

    return (
      <div className={styles.Crumb} onClick={this.onClick}>
        {formatRangeLabel(elevationMin, elevationMax, 0, ELEVATION_MAX, 'elevation', unitLabel)}
        <span className={styles.close}>
          <Icon i={'md-close'} />
        </span>
      </div>
    )
  }
}

export class FiltersCrumbs extends React.PureComponent {
  render () {
    const {query, doSearch, metricUnits} = this.props

    return (
      <div className={styles.FiltersCrumbs}>
        <SearchRangeCrumb location={query.get('start_location')} distance={query.get('start_distance')} query={query} doSearch={doSearch} metricUnits={metricUnits} />
        <LengthCrumb lengthMin={query.get('length_min')} lengthMax={query.get('length_max')} query={query} doSearch={doSearch} metricUnits={metricUnits} />
        <ElevationCrumb elevationMin={query.get('elevation_min')} elevationMax={query.get('elevation_max')} query={query} doSearch={doSearch} metricUnits={metricUnits} />
      </div>
    )
  }
}
